module.exports = __webpack_public_path__ + "static/media/13-item-a.d00946c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/13-item-a.jpg
// module id = 1197
// module chunks = 33